/** Fields of event content (or its card), shared by the frame and its card preview. */

export interface EventFields {
  title: string;
  month: string;
  day: string;
  detail: string;
  time: string;
  place: string;
}

export function eventFields(content: Record<string, unknown>): EventFields {
  const text = (key: string) =>
    typeof content[key] === "string" ? (content[key] as string) : "";
  return {
    title: text("title"),
    month: text("month"),
    day: typeof content.day === "number" ? String(content.day) : text("day"),
    detail: text("detail"),
    time: text("time"),
    place: text("place"),
  };
}

/** Whether the event has anything to show; else card and frame say so. */
export function hasEvent(fields: EventFields): boolean {
  return Object.values(fields).some(Boolean);
}
